<script lang="ts" setup>
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { MdiFaIcon } from '@ilteducation/components';
import { useDisplay } from 'vuetify';

type Props = {
  headerIcon?: string | IconDefinition;
  buttonPrependIcon?: string;
  buttonText?: string;
  subtitle?: string;
  loading?: boolean;
  buttonDisabled?: boolean;
  buttonClass?: string;
};
const { smAndUp, mdAndDown, xs, sm, md, lgAndUp } = useDisplay();

defineProps<Props>();
defineEmits(['button-clicked']);
</script>

<template>
  <v-sheet
    class="info-card pa-3 pa-sm-6 d-flex flex-grow-1"
    :class="{
      'flex-row': mdAndDown,
      'flex-column': !mdAndDown,
      'align-center': !mdAndDown,
      'align-start': md,
    }"
    rounded="lg"
  >
    <v-row v-if="smAndUp" class="ma-0 d-flex flex-grow-0">
      <v-col>
        <MdiFaIcon class="header-icon text-brand" size="48" :icon="headerIcon"></MdiFaIcon>
      </v-col>
    </v-row>
    <v-row class="ma-0 d-flex flex-column text-left" :class="{ 'ml-2': sm || md }">
      <v-col class="pa-0 d-flex flex-grow-0" :class="{ 'justify-center': lgAndUp }">
        <div class="text-subtitle-1 font-weight-bold">{{ subtitle }}</div>
      </v-col>
      <v-col class="d-flex justify-start px-lg-4 px-0 text-body-2 line-height-normal">
        <slot></slot>
      </v-col>
      <v-col class="pa-0 d-flex justify-center justify-sm-end justify-lg-center align-end">
        <v-btn
          :disabled="loading || buttonDisabled"
          color="primary"
          variant="flat"
          :prepend-icon="loading ? 'mdi-spin mdi-loading' : buttonPrependIcon"
          :class="buttonClass"
          :block="xs || lgAndUp"
          @click="() => $emit('button-clicked')"
        >
          <span v-if="buttonText" style="white-space: normal; word-break: break-word">
            {{ buttonText }}
          </span>
        </v-btn>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<style lang="scss" scoped>
@use 'sass:map';
@use 'vuetify/lib/styles/settings/variables' as *;

@media #{map.get($display-breakpoints, 'lg-and-up')} {
  .info-card {
    max-width: 301px;
    min-height: 351px;
  }
}

.line-height-normal {
  line-height: normal;
}
</style>
